import {financeAPI} from "../../axios";

export const state = {
    deliveryUnits: [],
    isDeliveryUnitsLoading: false,

}
export const mutations = {
    setDeliveryUnits(state, deliveryUnits) {
        state.deliveryUnits = deliveryUnits;
    },
    setIsDeliveryUnitsLoading(state, isDeliveryUnitsLoading) {
        state.isDeliveryUnitsLoading = isDeliveryUnitsLoading;
    }
}
export const actions = {
    getDeliveryUnitsByCampusAndCycle(context, {campusId,cycle}) {
        return financeAPI.get(`FinancePrePlanning/DeliveryUnits/${campusId}/${cycle}`)
    },
    getOPCRByDeliveryUnitIdAndCycle(context, {deliveryUnitId, cycle})
    {
        return financeAPI.get(`FinancePrePlanning/DeliveryUnit/OPCRs/${deliveryUnitId}/${cycle}`)
    },
    getAvailableFundSourcesByOpcrId(context, {opcrId})
    {
        return financeAPI.get(`FinancePrePlanning/DeliveryUnit/OPCR/FundSources/${opcrId}`)
    },
    getFinancePrePlanningObjectOfExpenditures(context, {opcrId, fundSourceId})
    {
        return financeAPI.get(`FinancePrePlanning/DeliveryUnit/BudgetItems/${opcrId}/${fundSourceId}`);
    },
    sendToActual(context, preOpcrId)
    {
        return financeAPI.post(`FinancePrePlanning/OPCR/SendToActual/${preOpcrId}`)
    }
}
export const getters = {}